import FilesForDownload from './views/file.c';
export default FilesForDownload;
